var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolidAngleRight = function SvgSolidAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "m1.445.25 2.52 2.524 1.546 1.54a1.676 1.676 0 0 1 0 2.366L1.445 10.75C.91 11.286 0 10.901 0 10.154V.848A.845.845 0 0 1 1.445.25"
  })));
};
export { SvgSolidAngleRight as ReactComponent };
export default __webpack_public_path__ + "a76009393b51fc4751f07084518a44ac.svg";